import React from 'react';
import ReactDOM from 'react-dom';


class MessagePortal extends React.PureComponent {
  constructor(props) {
    super(props);

    let messageDiv = document.createElement('div');
    messageDiv.className='container'
    this.target = document.getElementById('main') ? document.getElementById('main') : document.body;

    this.el = messageDiv;
  }

  componentDidMount() {
    this.target.insertBefore(this.el, this.target.childNodes[0])
  }

  componentWillUnmount() {
    this.target.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default MessagePortal;